module.exports = __webpack_public_path__ + "static/media/agtbg.ed5ef87c.png";